function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles } from '@material-ui/core';
const columnsToGridItemPropsMap = {
  1: {
    xs: 12
  },
  2: {
    xs: 12,
    sm: 6
  },
  3: {
    xs: 12,
    sm: 6,
    md: 4
  },
  4: {
    xs: 12,
    sm: 6,
    md: 3
  }
};
const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

const GridContainer = ({
  children,
  columns,
  wrapChildrenWithGridItem = true,
  className,
  ...props
} = {}) => {
  const classes = useStyles();
  children = React.Children.toArray(children);
  let gridItemProps;

  if (typeof columns === 'number') {
    gridItemProps = columnsToGridItemPropsMap[columns];
  } else if (columns !== 'none') {
    gridItemProps = columnsToGridItemPropsMap[children.length] || columnsToGridItemPropsMap[1];
  }

  return React.createElement(Grid, _extends({
    container: true,
    spacing: 2,
    className: `${classes.container} ${className || ''}`
  }, props), wrapChildrenWithGridItem ? children.map((child, index) => React.createElement(Grid, _extends({
    key: index,
    item: true
  }, gridItemProps), child)) : children);
};

GridContainer.propTypes = {
  columns: PropTypes.oneOf(['none', 1, 2, 3, 4]),
  wrapChildrenWithGridItem: PropTypes.bool
};
export default GridContainer;